import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { FormSection } from '../formSection/FormSection'
import { FieldSection } from '../formSection/fieldSection/FieldSection'
import { AddNewProgramFormModel } from '../AddNewProgram.types'

import { FormField, TextInput, getInputStatus } from '@percent/lemonade'

export function Other() {
  const { t } = useTranslation()

  const {
    register,
    formState: { errors }
  } = useFormContext<AddNewProgramFormModel>()

  return (
    <FormSection title={t('form.other')}>
      <FieldSection>
        <FormField
          label={t('form.primaryColor')}
          status={getInputStatus(errors.primaryColor?.message)}
          statusMessage={errors.primaryColor?.message}
        >
          <TextInput {...register('primaryColor')} placeholder={t('form.primaryColorPlaceholder')} />
        </FormField>
      </FieldSection>
      <FieldSection>
        <FormField
          label={t('form.programWebsite')}
          status={getInputStatus(errors.programWebsite?.message)}
          statusMessage={errors.programWebsite?.message}
        >
          <TextInput {...register('programWebsite')} placeholder={t('form.programWebsitePlaceholder')} />
        </FormField>
      </FieldSection>
    </FormSection>
  )
}
